import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Alert,
  Stack
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const PageWrapper = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: '#f5f6fa',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
}));

const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 500,
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: theme.shadows[4],
  backgroundColor: '#ffffff'
}));

const UpdateEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
   const [originalEmail, setOriginalEmail] = useState('');

  useEffect(() => {
    // Fetch current email on mount
    const fetchCurrentEmail = async () => {
      try {
        const res = await axios.get('/updateEmail.php', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        setEmail(res.data.email);
        setOriginalEmail(res.data.email);
      } catch (err) {
        setError('Failed to load current email.');
      }
    };
    fetchCurrentEmail();
  }, []);

  const validateEmail = (email) => {
    // Basic email regex validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!validateEmail(email)) {
      return setError('Please enter a valid email address.');
    }
if (email.toLowerCase() === originalEmail.toLowerCase()) {
  return setError('New email must be different from the current email.');
}

    try {
      await axios.post('/updateEmail.php', { email }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setSuccess('Email updated successfully. Please log in again.');
      localStorage.removeItem('token');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred.');
    }
  };

  return (
    <PageWrapper>
      <StyledCard>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, textAlign: 'center', mb: 3 }}>
            Update Admin Email
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                label="Email"
                fullWidth
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}

              <Button
                variant="contained"
                type="submit"
                sx={{ backgroundColor: '#1E88E5', fontWeight: 600, py: 1.5 }}
              >
                Update Email
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </StyledCard>
    </PageWrapper>
  );
};

export default UpdateEmail;
